import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'abbreviateNumber'
})

export class AbbreviateNumberPipe implements PipeTransform {
  transform(originalValue: any): any {
    let valueToReturn: any = originalValue;
    try {
      const newNumber = +valueToReturn && +valueToReturn.toString().replace('.', '');
      if (typeof newNumber === 'number' && newNumber >= 1000) {
        const suffixes = ['', 'K', 'M', 'B', 'T'];
        const suffixNum = Math.floor(('' + newNumber).length / 3);
        let shortValue;
        for (let precision = 3; precision >= 1; precision--) {
          shortValue = parseFloat((suffixNum != 0 ? (newNumber / Math.pow(1000, suffixNum)) : newNumber).toPrecision(precision));
          const dotLessShortValue = (shortValue + '').replace(/[^a-zA-Z 0-9]+/g, '');
          if (dotLessShortValue.length <= 3) { break; }
        }
        if (shortValue % 1 != 0) shortValue = shortValue.toFixed(1);
        valueToReturn = shortValue + suffixes[suffixNum];
        return valueToReturn;
      }
      return valueToReturn;
    } catch (error) {
      return valueToReturn;
    }
  }

}
